export function showDomain(url: string): string {
  const parts = url.split('://')
  if (parts.length === 1) {
    return url.split('/')[0]
  }

  return parts.slice(1, parts.length).join('://').split('/')[0]
}